import axios from "axios";
import { naZnacznik } from "../utils/sentWalidacja";
import {
    SentDeklaracjaCreateInterface,
    SentDeklaracjaInterface,
    SentIdModel,
    SentPojazdInterface
} from "../redux/sent/sent.type";

/**
 * ==========================================================================
 *  API SENT — mygps-api, sciezki zakresowane obszarem
 * ==========================================================================
 *
 *   GET    /api/v1/workspaces/{uuid}/sent           -> 200, tablica deklaracji
 *   GET    /api/v1/workspaces/{uuid}/sent/vehicles  -> 200, tablica pojazdow
 *   POST   /api/v1/workspaces/{uuid}/sent           <- {vehicleId, startDate, endDate}
 *                                                   -> 201 {"id": N}
 *   DELETE /api/v1/workspaces/{uuid}/sent/{id}      -> 204
 *                                     powtorne      -> 409 already_deleted
 *
 * KSZTALT ODPOWIEDZI ZMIERZONY NA ZYWO 2026-09-14 (obszar MIK TRANS), bo
 * specyfikacja go nie opisuje — zadna z czterech operacji nie ma `schema`.
 * Odpowiedzi to GOLE TABLICE, bez koperty, w snake_case:
 *
 *   /sent/vehicles:
 *     {"vehicle_id": 20304, "sent_token": "U21-AC41WR-1",
 *      "licence_number": "WGM95519"}
 *
 *   /sent:
 *     {"id": 1, "create_date": "2026-09-14 08:08:34",
 *      "start_date": "2026-09-14 00:00:00", "end_date": "2026-09-16 23:59:59",
 *      "vehicle_licence_number": "WGM95519", "vehicle_id": 20304,
 *      "vehicle_sent_token": "U21-AC41WR-1", "customer": "...",
 *      "created_by": "Wayfayer3User: ..."}
 *
 * DWIE OBSERWACJE Z POMIARU:
 *
 *  1. Zadanie POST przyjmuje daty jako `Y-m-d`, ale odpowiedz zwraca je jako
 *     date-time, z koncem ustawionym na 23:59:59. Backend traktuje wiec dzien
 *     konca jako WLICZONY w calosci — zgodnie z nasza interpretacja limitu
 *     10 dni (patrz utils/sentWalidacja.ts).
 *
 *  2. Nazwy pol sa w snake_case, czyli jak w reszcie mygps-api — inaczej niz
 *     w pierwotnym kontrakcie Endomoto, na ktory modul byl pisany.
 *
 * Mapowanie snake_case -> camelCase jest TYLKO TUTAJ. Reszta modulu widzi
 * jeden ksztalt, wiec zmiana kontraktu dotknie wylacznie tego pliku.
 */

/** Odpowiedzi sa golymi tablicami; osłona na wypadek pustej odpowiedzi. */
function lista(dane: any): any[] {
    return Array.isArray(dane) ? dane : [];
}

function naPojazd(x: any): SentPojazdInterface {
    return {
        vehicleId: x.vehicle_id,
        sentToken: x.sent_token || "",
        licenceNumber: x.licence_number || ""
    };
}

function naDeklaracje(x: any): SentDeklaracjaInterface {
    return {
        id: x.id,
        createDate: x.create_date,
        startDate: x.start_date || "",
        endDate: x.end_date || "",
        // Przeliczamy tu, bo to jedyne miejsce, przez ktore przechodzi
        // kazda deklaracja — i przechodzi dokladnie raz.
        startTs: naZnacznik(x.start_date),
        endTs: naZnacznik(x.end_date),
        vehicleId: x.vehicle_id,
        vehicleLicenceNumber: x.vehicle_licence_number || "",
        vehicleSentToken: x.vehicle_sent_token || "",
        customer: x.customer,
        createdBy: x.created_by
    };
}

const sciezka = (uuid: string) => `/api/v1/workspaces/${uuid}/sent`;

/** Pojazdy z integracja SENT — tylko z obszaru podanego w sciezce. */
async function getSentPojazdyApi(uuid: string): Promise<SentPojazdInterface[]> {
    const odp = await axios({ method: "GET", url: `${sciezka(uuid)}/vehicles` });
    return lista(odp && odp.data).map(naPojazd);
}

/** Lista deklaracji obszaru. */
async function getSentDeklaracjeApi(uuid: string): Promise<SentDeklaracjaInterface[]> {
    const odp = await axios({ method: "GET", url: sciezka(uuid) });
    return lista(odp && odp.data).map(naDeklaracje);
}

/** Rejestracja deklaracji. Zwraca 201 z identyfikatorem utworzonego zgloszenia. */
async function postSentDeklaracjaApi(
    uuid: string,
    data: SentDeklaracjaCreateInterface
): Promise<SentIdModel> {
    const odp = await axios({ method: "POST", url: sciezka(uuid), data });
    const d = odp && odp.data;
    return { id: d && d.id !== undefined ? d.id : 0 };
}

/** Wycofanie deklaracji. Odpowiedz 204 nie ma ciala. */
async function deleteSentDeklaracjaApi(uuid: string, id: number | string): Promise<void> {
    await axios({ method: "DELETE", url: `${sciezka(uuid)}/${id}` });
}

export {
    getSentPojazdyApi,
    getSentDeklaracjeApi,
    postSentDeklaracjaApi,
    deleteSentDeklaracjaApi
};
